import Nullstack from 'nullstack';
export default function IconMusic({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-music",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "17",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "17",
    r: "3"
  }), "   ", Nullstack.element("polyline", {
    points: "9 17 9 4 19 4 19 17"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "8",
    x2: "19",
    y2: "8"
  }), " ");
}